module.exports = __webpack_public_path__ + "static/ConsumerSignUp2-02517d3484ac79ea829fd7f0837914a8.png";